import PropTypes from 'prop-types'
import React from 'react'
import {format} from 'ag-common/facades'
import FeedbackDownloadButton from '#components/m/Feedback/FeedbackDownloadButton'
import FeedbackUserDisplayField from '#components/m/Feedback/FeedbackUserDisplayField'
import FeedbackTitleWithIcon from '#components/m/Feedback/FeedbackTitleWithIcon'

export function FeedbackRowAsAzubi({feedback, downloadFile}) {
  const {author, uploadDate} = feedback
  const formattedUploadDate = format(new Date(uploadDate), 'dd. MMMM yyyy')

  return (
    <tr data-testid="feedback-row">
      <td>
        <div>
          <FeedbackTitleWithIcon feedback={feedback} />
        </div>
      </td>
      <td>
        <div>
          <FeedbackUserDisplayField user={author} />
        </div>
      </td>
      <td>
        <div>
          <span>{formattedUploadDate}</span>
        </div>
      </td>
      <td>
        <FeedbackDownloadButton feedback={feedback} downloadFile={downloadFile} />
      </td>
    </tr>
  )
}

FeedbackRowAsAzubi.propTypes = {
  feedback: PropTypes.shape({
    id: PropTypes.string,
    author: PropTypes.shape({
      firstname: PropTypes.string,
      lastname: PropTypes.string,
      id: PropTypes.number,
      hasErrors: PropTypes.bool,
    }),
    originalFilename: PropTypes.string,
    uploadDate: PropTypes.any,
  }),
  downloadFile: PropTypes.func.isRequired,
}
